// extracted by mini-css-extract-plugin
module.exports = {"header":"GuideHeader_header__2msIL","inner":"GuideHeader_inner__2ox6A","title":"GuideHeader_title__1GvG1","step":"GuideHeader_step__e4pPk"};